import { useRef } from "react";

export const useLatestRef = (target) => {
  const targetRef = useRef(target);
  targetRef.current = target;

  return targetRef;
};
